import { useEffect, useState,  } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { WMSInput } from "../../widgets/input";
import { useNavigate, useParams } from "react-router-dom";
import Capture from "../../images/Capture.png";
import { apiUrl } from "../../base/utils";
import { toastError, toastSuccess } from "../../widgets/toaster";
import { invokePostService,invokeGetService } from "../../service";
import WHSLoader from "../../widgets/loader";
import Peerlogo from "../../images/logo-peer-ease.png";
import IntegraLogo from "../../images/integra-logo.png";

function UserPassword(props:any) {
  const [savedUsername, setSavedUserName] = useState("");
  const [savedPassword, setSavedPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [password, setPassword] = useState(true);
  const [conformpassword, setConformPassword] = useState("");
  const [conformpasswordview, setConformPasswordView] = useState(true);
  const [resetUser, setResetUser] = useState("");
  const [confirmError, setconfirmError] = useState(null);
  const [passwordmError, setpasswordmError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const { optionalParam } = useParams();
  const [userEmail, setUserEmail] = useState("");
  const [userKey, setUserKey] = useState("");
  const [isLoader, setLoader] = useState(false);
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

useEffect(() => {
    let match = optionalParam && optionalParam.match(/(?<=key\=)(?:.*)/);
    if (match && match.length > 0) {
      let extractedValue = atob(match[0]);
     getResetLinkData(extractedValue);

    }
  },[]);
 const getResetLinkData = async (key: any) => {
    try {
        let url = apiUrl.nodeApi.GetResetLinkData;
        const queryParams = {
          key : key,
          isSet: (searchParams.get('isSet') === 'true') ? true : false
        };
 
        const response: any = await invokeGetService(url, {}, queryParams, '')
        console.log(response,"werew");
        if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
        // let match = optionalParam && optionalParam.match(/(?<=key\=)(?:.*)/);

        let userData = response.data.data.result;
        setSavedUserName(userData?.firstname);
        setUserEmail(userData?.email);
        setUserKey(userData?.key);
        setUserId(userData?.userid);
        setIsPasswordReset(userData?.uniqueKey);
    } catch (error) {
      toastError(`${error}`)
    }
}
  const handleFormChange = (e: any, type: any) => {
    if (type === "username" && e !== "") {
      setSavedUserName(e.target.value);
    } else if (type === "password" && e !== "") {
      setSavedPassword(e.target.value);
      if (e.target.value.length >= 8) {
        setpasswordmError(null);
      }
      if (conformpassword !== e.target.value) {
        setconfirmError(null);
      }
    } else if (type === "conformpassword" && e !== "") {
      setConformPassword(e.target.value);
      if (savedPassword !== e.target.value) {
        setconfirmError(null);
      }
    }
    setSubmitted(false);
  };

  const togglePassword = () => {
    setPassword(!password);
  };

  const toggleConfirmPassword = () => {
    setConformPasswordView(!conformpasswordview);
  };
  const validateFields = () => {
    let confirmError: any = "";
    let passwordError: any = "";
    if (conformpassword !== savedPassword) {
      confirmError = "Please validate that the passwords are distinct.";
    }
    if (savedPassword.length < 8) {
      passwordError = "Password must be at least 8 characters long.";
    }

    if (conformpassword.length < 8) {
      confirmError = "Confirm Password must be at least 8 characters long.";
    }

    if (passwordError || confirmError) {
      setpasswordmError(passwordError);
      setconfirmError(confirmError);
      return false;
    } else {
      setpasswordmError(null);
      setconfirmError(null);
      return true;
    }
  };

  const handleSubmit = async () => {
    try {
      setSubmitted(true);
      if (validateFields()) {
        if (conformpassword && savedPassword) {
          let payload = {
            password: savedPassword,
            email: userEmail,
            key: userKey,
            userid: userId,
          };
          let url = apiUrl.nodeApi.PasswordReset;
          setLoader(true);
          const response: any = await invokePostService(url, payload, {});
          setLoader(false);
          if (!response.data.data.isSuccess) {
            throw new Error(response.data.data.Error);
          } else {
            toastSuccess("Successfully updated password");
            navigate("/");
          }
        }
      }
      localStorage.removeItem("savedUsername");
      localStorage.removeItem("savedPassword");
      localStorage.setItem("rememberMe", "false");
    } catch (error) {
      setLoader(false);
      toastError(`Set password failed ${error}`);
    }
  };

  const handleKeyPress = (e: any, type: any) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <>
      {isLoader && <WHSLoader></WHSLoader>}
      <div className="login-page">
        <div className="left-side">
          {/* <div>
                        <img src={Logo} />
                    </div> */}
          <div className="capture">
            {/* <h1>Peer Review System</h1> */}
            <div>
              <img src={Peerlogo} alt="peerease" className="demo" />
              {/* <img src={Capture} /> */}
            </div>
          </div>
          <div className="left-side-bottom">
            <p>
              Powered by <img src={IntegraLogo} alt="integra-logo" /> | All
              Rights Reserved
            </p>
          </div>
        </div>
        <div className="right-side">
          <div className="right-side-main">
            <div className="right-side-inner">
              <h1>{isPasswordReset ? "Reset Password" : "Add New Password"}</h1>
              <div>
                <div className="form-group">
                  <label>Login Id</label>
                  <WMSInput
                    type="text"
                    disabled={true}
                    placeHolder="Enter username"
                    className="form-control"
                    value={userEmail}
                    maxLength=""
                    onChange={(e: any) => handleFormChange(e, "username")}
                    id="username"
                  />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <WMSInput
                    type={password === true ? "password" : "text"}
                    placeHolder="Enter New Password"
                    className="form-control"
                    value={savedPassword}
                    maxLength=""
                    onChange={(e: any) => handleFormChange(e, "password")}
                    id="password"
                  />
                  {password === true ? (
                    <span
                      className="material-icons visibleIcons"
                      onClick={() => togglePassword()}
                    >
                      visibility
                    </span>
                  ) : (
                    <span
                      className="material-icons visibleIcons"
                      onClick={() => togglePassword()}
                    >
                      visibility_off
                    </span>
                  )}
                  {submitted && savedPassword ? (
                    <span className="error">{passwordmError}</span>
                  ) : null}
                  {submitted && !savedPassword ? (
                    <span className="error">Password is required</span>
                  ) : null}
                </div>
                <div className="form-group">
                  <label>Confirm Password</label>
                  <WMSInput
                    onKeyPress={(e: any) => handleKeyPress(e, "forget")}
                    type={conformpasswordview === true ? "password" : "text"}
                    placeHolder="Confirm New Password"
                    className="form-control"
                    value={conformpassword}
                    maxLength=""
                    onChange={(e: any) =>
                      handleFormChange(e, "conformpassword")
                    }
                    id="conformpassword"
                  />
                  {conformpasswordview === true ? (
                    <span
                      className="material-icons visibleIcons"
                      onClick={() => toggleConfirmPassword()}
                    >
                      visibility
                    </span>
                  ) : (
                    <span
                      className="material-icons visibleIcons"
                      onClick={() => toggleConfirmPassword()}
                    >
                      visibility_off
                    </span>
                  )}
                  {submitted && conformpassword ? (
                    <span className="error">{confirmError}</span>
                  ) : null}
                  {submitted && !conformpassword ? (
                    <span className="error">Confirm Password is required</span>
                  ) : null}
                </div>
                <Button className="btn" onClick={() => handleSubmit()}>
                  Submit
                </Button>
              </div>
            </div>
          </div>
          <div className="right-side-bottom">
            <p>
              Powered by <strong>Integra</strong> | All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserPassword;
